import { Text } from '../../../cdl/Text/Text';
import { translate } from '../../helpers/translate.helper';
import { useRole } from '../../hooks/useRole';
import { InfoPopover } from '../../InfoPopover/InfoPopover';
import { Box } from '../../ui/Box';

export const AttachmentsInfoPopover = () => {
    const role = useRole();

    const getInfoTranslationKey = () => {
        if (role.isSuperAdmin()) {
            return 'offer.detail.attachments.info.admin';
        }
        if (role.isCustomer()) {
            return 'offer.detail.attachments.info.customer';
        }
        return 'offer.detail.attachments.info.supplier';
    };

    return (
        <InfoPopover side="right" width="300px">
            <Box display="flex" flexDirection="column">
                <Text variant="extraSmall" style={{ fontWeight: 700 }}>
                    {translate('offer.detail.attachments.info.header')}
                </Text>
                <Text variant="extraSmall">{translate(getInfoTranslationKey())}</Text>
            </Box>
        </InfoPopover>
    );
};
